import { useHistory, useParams } from 'react-router-dom';

import { setApplicationLanguage } from 'flow/actions/app-actions';
import Page from 'flow/components/Setting/Page';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectApplicationLanguage } from 'flow/selectors/app-selectors';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { LocalesData } from 'flow/utils/locales-data';
import { generatePath } from 'flow/utils/router-utils';
import SettingSelectableItem from 'flow/components/ui-components/SettingSelectableItem';

const SettingsGeneralLocaleChange = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const appLanguage = useAppSelector(selectApplicationLanguage);

    const setAppLanguage = (languageCode: keyof typeof LocalesData) => {
        dispatch(setApplicationLanguage(languageCode));
        history.push(
            generatePath(routes['settings.general'], { extensionKey }),
        );
    };

    return (
        <Page
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.general'], { extensionKey }),
                )
            }
            header={'settings.language'}
        >
            <div className="pb-4">
                {Object.entries(LocalesData).map(([locale, localeData]) => (
                    <SettingSelectableItem
                        key={`languageEnumItem-option-${locale}`}
                        value={locale}
                        onClick={setAppLanguage}
                        selected={locale === appLanguage ? locale : ''}
                    >
                        {localeData.description}
                    </SettingSelectableItem>
                ))}
            </div>
        </Page>
    );
};

export default SettingsGeneralLocaleChange;
